import { jsx as _jsx } from "react/jsx-runtime";
import Stack from '@mui/material/Stack';
import { forwardRef } from 'react';
export const DataTable = forwardRef(function DataTable({ children }, ref) {
    return (_jsx(Stack, { direction: "column", ref: ref, children: children }));
});
